module.exports = __webpack_public_path__ + "socicon.ac281a9ac6be8ad18914.svg";


//////////////////
// WEBPACK FOOTER
// ./~/socicon/font/socicon.svg
// module id = 245
// module chunks = 13